import { Component, OnInit} from '@angular/core';
import { LoadingPage } from '../../../compartido/cargando/loading';
import { DisponibilidadPlanificacion, DisponibilidadDTO } from 'npm-modelado-catering';
import { DisponibilidadService, CateringUnidadService, AsociacionJefeDependenciaService } from 'npm-servicios-catering';
import { DatosSesionService } from '../../servicios/datos-sesion.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Constantes } from '../../../compartido/constantes/constantes';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { Unidad } from "modelo-unidad-servicio-sga";
import { Persona } from '../../../compartido/modelado-compartido/persona';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-disponibilidad-planificacion-excepcional-crear',
  templateUrl: './disponibilidad-planificacion-excepcional-crear.component.html',
  styleUrls: ['./disponibilidad-planificacion-excepcional-crear.component.css']
})
export class DisponibilidadPlanificacionExcepcionalCrearComponent extends LoadingPage implements OnInit {

  disponibilidadExcepcional: DisponibilidadPlanificacion;
  disponibilidadDTO : DisponibilidadDTO;
  tituloPagina: string;
  nuevaFechaDisponibilidad: boolean;
  idFechaDisponibilidad: number;
  personaRecuperada: Persona;
  identificacionRecuperada: String;
  identificacionBusquedaPersona: String;
  nombresPersona: String;
  correoPersona: String;

  unidadSeleccionada: Unidad;
  busy: Subscription;
  lstUnidad = Unidad

  existe: boolean;
  idPersona: string;
  textoBusquedaUnidad: string = "";
  lstPersonasResultados: Persona[];
  lstPersonasResultadosAdministrativos: Persona[];
  lstPersonasResultadosDocentes: Persona[];
  selectedPersonaBusqueda: Persona;
  selectedPersona: Persona;
  mostrandoBuscarPersona: boolean;
  flagEncuentraPersona: boolean=false;
  deshabilitaBusqueda: boolean;
  loadingBusqueda: boolean;

  constructor(private disponibilidadService: DisponibilidadService,
              private datosSesionService: DatosSesionService,
              private router: Router, private routeParams: ActivatedRoute,
              private cateringUnidadService: CateringUnidadService, public datepipe: DatePipe,
              private asociacionJefeDependenciaService: AsociacionJefeDependenciaService) { 
    super(false);
  }

  ngOnInit() {
     this.disponibilidadDTO = new DisponibilidadDTO();

    this.cargarEnviroments();
    this.nuevaFechaDisponibilidad=false;
 
    if (this.routeParams.snapshot.queryParams['id']) {
      this.idFechaDisponibilidad = this.routeParams.snapshot.queryParams['id'];
      
      this.tituloPagina = this._tituloDetalle;
      this.recuperarDisponibilidad();
		} else {
	  		this.tituloPagina = this._crearFichaDisponibilidadPlanificacion;
        this.nuevaFechaDisponibilidad = true;
        this.obtenerUnidades();
	      this.tituloPagina = this._tituloCrearDisponibilidadExcepcional;
        
    }
    this.disponibilidadExcepcional = new DisponibilidadPlanificacion();
    
  }

  

  recuperarDisponibilidad(){
      if(!this.nuevaFechaDisponibilidad){
       
        this.disponibilidadService.buscarDisponibilidadDTO(this.idFechaDisponibilidad).then(responseRecuperaDisponibilidad=>{
          if(responseRecuperaDisponibilidad){          
            this.disponibilidadDTO= responseRecuperaDisponibilidad;          
          }
        })
      }
  }

  obtenerUnidades() {
    const urlUnidad = environment.URL_UNIDAD;
    this.busy = this.cateringUnidadService.listarUnidadServicio(urlUnidad).then(unidades => {
      if (unidades) {
        this.lstUnidad = unidades;
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  buscarPersonaPorIdentificacion() {

    const urlPersona = environment.URL_PERSONA;
    this.busy = this.asociacionJefeDependenciaService.buscarPorId(urlPersona, this.identificacionBusquedaPersona).then(persona => {
      if (persona) {
        this.personaRecuperada = persona;
        this.correoPersona = this.personaRecuperada.correoInstitucional;

        this.nombresPersona = "";
        if (this.personaRecuperada.nombrePrimero.length > 2) {
          this.nombresPersona = this.nombresPersona + this.personaRecuperada.nombrePrimero;
        }
        if (this.personaRecuperada.nombreSegundo.length > 2) {
          this.nombresPersona = this.nombresPersona + " " + this.personaRecuperada.nombreSegundo;
        }
        if (this.personaRecuperada.apellidoPrimero.length > 2) {
          this.nombresPersona = this.nombresPersona + " " + this.personaRecuperada.apellidoPrimero;
        }
        if (this.personaRecuperada.apellidoSegundo.length > 2) {
          this.nombresPersona = this.nombresPersona + " " + this.personaRecuperada.apellidoSegundo;
        }
        this.identificacionRecuperada = this.personaRecuperada.identificacion;
        this.idPersona= persona.idPersona;
      } else {
        console.log("No se encuentra");
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  
  cargarEnviroments(){
    this.disponibilidadService.set_constantes(Constantes);
  }

   clickGuardar(){
      
      if(this.validarCamposAlmacencar()){
          this.guardarFechaDisponibilidad();
      }
  }

  async guardarFechaDisponibilidad(){

    this.disponibilidadExcepcional.tipoDisponibilidad=Constantes.TIPO_DISPONIBILIDAD_EXCEPCIONAL;
    this.disponibilidadExcepcional.estaActivo= Constantes.ESTA_ACTIVO_SI;
    this.disponibilidadExcepcional.idPersonaAutoriza=this.idPersona;
    this.disponibilidadExcepcional.idDependencia=this.unidadSeleccionada.idUnidad;

    await this.buscarDisponibilidadPorDependencia();

    if(!this.existe){
        this.disponibilidadService.crear(this.disponibilidadExcepcional).then(responseFechaDisponibilidad=>{
          if(responseFechaDisponibilidad){
            this.redireccionarListadoExito(true);
          }
        }).catch(error => this.mostrarMensajeError(error));
    }else{
      this.mostrarMensajeError(this._validacionCrearDisponibilidadExcepcionalMes);
    }

  }
    
    
  buscarDisponibilidadPorDependencia(){
    return new Promise(resolve =>{
        this.disponibilidadService.buscarDisponibilidadExcepcionalPorDependencia(this.disponibilidadExcepcional.fechaInicio,
           this.disponibilidadExcepcional.fechaFin, this.disponibilidadExcepcional.idDependencia, this.disponibilidadExcepcional.horaInicio).then(resultBusqueda=>{
          if(resultBusqueda==true){
            this.existe=true;
            resolve();
          }else{
            this.existe=false;
            resolve();
          }
        }).catch(error => this.mostrarMensajeError(error));
      });
  }

  redirectListado() {
		this.router.navigate(['/configuracion/disponibilidad-planificacion-excepcional-listar/']);
  }
  
  redireccionarListadoExito( exito: boolean){
    this.datosSesionService.exitoGuardandoDisponibildadPlanificacion=exito;
		this.router.navigate(['/configuracion/disponibilidad-planificacion-excepcional-listar/']);
  }

  validarCamposAlmacencar(): boolean{
    try{
      let fechaActual = new Date();
      let resultado=true;
      let mensajeError = this._tituloMensajeValidacionGrupal;

      if(!this.disponibilidadExcepcional || this.disponibilidadExcepcional.fechaInicio == null ){
        mensajeError += this._saltoLineaDetalle + this._validarCampoFechaInicioDisponibilidad;
				resultado = false;
      }

      if(!this.disponibilidadExcepcional || this.disponibilidadExcepcional.fechaFin == null ){
        mensajeError += this._saltoLineaDetalle + this._validarCampoFechaFinDisponibilidad;
				resultado = false;
      }

      if(this.disponibilidadExcepcional.fechaInicio > this.disponibilidadExcepcional.fechaFin ){
        mensajeError += this._saltoLineaDetalle + this._validarRangoFechaDisponibilidad;
				resultado = false;
      }

      if(!this.disponibilidadExcepcional || !this.disponibilidadExcepcional.observacion || this.disponibilidadExcepcional.observacion.trim().length <= 0 ){
        mensajeError += this._saltoLineaDetalle + this._validacionObservacionesRequeridas;
        resultado= false;
      }
      
      if(this.disponibilidadExcepcional && this.disponibilidadExcepcional.observacion && this.disponibilidadExcepcional.observacion.trim().length > 250  ){
        mensajeError += this._saltoLineaDetalle + this._validacionMaximoObservaciones;
        resultado= false;
      }else if (this.disponibilidadExcepcional.observacion){
          this.disponibilidadExcepcional.observacion = this.disponibilidadExcepcional.observacion.trim();
      }

      if(!this.personaRecuperada || this.personaRecuperada.identificacion.trim().length < 0 ){
        mensajeError += this._saltoLineaDetalle + this._validarPersonaAutoriza;
        resultado= false;
      }

      if(!this.unidadSeleccionada || this.unidadSeleccionada.idUnidad <=0){
        mensajeError += this._saltoLineaDetalle + this._dependenciaRequerida;
        resultado= false;
      }

      if(this.disponibilidadExcepcional.fechaFin && this.disponibilidadExcepcional.fechaInicio && 
        this.disponibilidadExcepcional.fechaInicio.getMonth()!=this.disponibilidadExcepcional.fechaFin.getMonth()){
        mensajeError += this._saltoLineaDetalle + this._validacionFechasIngresadas;
				resultado = false;
      }

      if(this.disponibilidadExcepcional.fechaInicio && this.disponibilidadExcepcional.fechaInicio.getDate() < fechaActual.getDate()){
        mensajeError += this._saltoLineaDetalle + this._mensajeCreacionDisponibildadExcepcional;
				resultado = false;
      }

      if(this.disponibilidadExcepcional.fechaInicio && this.disponibilidadExcepcional.fechaInicio.getMonth() > fechaActual.getMonth()){
        mensajeError += this._saltoLineaDetalle + this._mensajeCrearDisponibilidadExcepcionaMesActual;
				resultado = false;
      }
      
      if(this.disponibilidadExcepcional && this.disponibilidadExcepcional.horaInicio ==null){
        mensajeError += this._saltoLineaDetalle + "El campo hora inicio es requerido";
        resultado= false;
      }

      if(this.disponibilidadExcepcional && this.disponibilidadExcepcional.horaFin ==null){
        mensajeError += this._saltoLineaDetalle + "El campo hora fin es requerido";
        resultado=false;
      }

      if(this.disponibilidadExcepcional && this.disponibilidadExcepcional.horaInicio && this.disponibilidadExcepcional.horaFin ){

        let horaInicio = this.datepipe.transform(this.disponibilidadExcepcional.horaInicio.setSeconds(0), 'HH:mm:ss');
        let horaFin = this.datepipe.transform(this.disponibilidadExcepcional.horaFin.setSeconds(0), 'HH:mm:ss');
    
        if(horaFin <= horaInicio){
          mensajeError += this._saltoLineaDetalle + "La hora inicio debe ser menor a la  hora fin";
          resultado = false;
        }
      }

      if(!resultado){
          this.mostrarMensajeError(mensajeError);
      }
      return resultado;

    }catch(error){
      console.error("ERROR. ValidarCamposAlmacenar", error);
			return false;
    }
    
  }
  construirNombre(personaRecuperada) {
    
    if (personaRecuperada.apellidoPrimero != null) {
      if (personaRecuperada.apellidoPrimero.length > 0) {
        this.nombresPersona = this.nombresPersona + " " + personaRecuperada.apellidoPrimero;
      }
    }
    if (personaRecuperada.apellidoSegundo != null) {
      if (personaRecuperada.apellidoSegundo.length > 0) {
        this.nombresPersona = this.nombresPersona + " " + personaRecuperada.apellidoSegundo;
      }
    }
    if (personaRecuperada.nombrePrimero != null) {
      if (personaRecuperada.nombrePrimero.length > 0) {
        this.nombresPersona = this.nombresPersona + " " + personaRecuperada.nombrePrimero;
      }
    }
    if (personaRecuperada.nombreSegundo != null) {
      if (personaRecuperada.nombreSegundo.length > 0) {
        this.nombresPersona = this.nombresPersona + " " + personaRecuperada.nombreSegundo;
      }
    }
  }

  clickBuscarPersonaClaseCriterio() {
    if (this.textoBusquedaUnidad.trim().length > 0) {
      const urlPersona = environment.URL_PERSONA;
      this.lstPersonasResultados = undefined;
      let textoBusquedaUnidadtmp = this.textoBusquedaUnidad;

      if (!Constantes.caracteresRegex.test(textoBusquedaUnidadtmp)) {
        this.mostrarMensajeError(this._nosePermitenCaracteresEspeciales);
        return;
      } else {
        this.busy = this.asociacionJefeDependenciaService.buscarPersonaClaseCriterio(urlPersona, "ADMINISTRATIVO", this.textoBusquedaUnidad).then(responseBusqueda => {
          this.mensaje = [];
          this.lstPersonasResultados = responseBusqueda;
          
          this.busy = this.asociacionJefeDependenciaService.buscarPersonaClaseCriterio(urlPersona, "DOCENTE", this.textoBusquedaUnidad).then(responseBusqueda => {
            this.lstPersonasResultadosDocentes = responseBusqueda;            
            this.lstPersonasResultadosDocentes.forEach(async docente => {
              this.flagEncuentraPersona=false;
              await this.buscaPersonaIgual(docente);
              if (!this.flagEncuentraPersona){
                this.lstPersonasResultados.push(docente);
              }              
            });
            
            this.loadingBusqueda = false;
          }).catch(error => {
            this.loadingBusqueda = false;
            this.mostrarMensajeError(error);
          });
          this.loadingBusqueda = false;
        }).catch(error => {
          this.loadingBusqueda = false;
          this.mostrarMensajeError(error);
        });
      }
      this.loadingBusqueda = true;

    } else {
      this.mostrarMensajeError("Debe ingresar el número de cédula o los nombres de la persona a buscar");
    }
  }  
  buscaPersonaIgual(docente){
    this.lstPersonasResultados.forEach(async administrativo => {
      if (docente.identificacion == administrativo.identificacion){
        this.flagEncuentraPersona=true;
      }
    });
  }
  async clickSeleccionarPersona() {
    if (this.selectedPersonaBusqueda.correoInstitucional != null) {
      if (this.selectedPersonaBusqueda.correoInstitucional.localeCompare("No Definido") != 0) {
        this.selectedPersona = Object.assign({}, this.selectedPersonaBusqueda);
        this.personaRecuperada = Object.assign({}, this.selectedPersonaBusqueda);
        this.mostrandoBuscarPersona = false;        
        this.nombresPersona=""
        await this.construirNombre(this.selectedPersonaBusqueda);        
        this.mostrarMensajeInfo("Se ha seleccionado correctamente");
        this.idPersona= this.selectedPersonaBusqueda.idPersona;
      } else {
        this.selectedPersona = Object.assign({}, this.selectedPersonaBusqueda);
        await this.construirNombre(this.selectedPersonaBusqueda);  
        this.mostrarMensajeInfo("La persona seleccionada no tiene asociado un correo, por lo cual no puede ser ingresada, por favor comuníquese con la Dirección de Tecnologías para que le sea asignado un correo.");
        
        this.mostrandoBuscarPersona = true;
      }
    } else {
      this.selectedPersona = Object.assign({}, this.selectedPersonaBusqueda);
      await this.construirNombre(this.selectedPersonaBusqueda);  
      this.mostrarMensajeInfo("La persona seleccionada no tiene asociado un correo, por lo cual no puede ser ingresada, por favor comuníquese con la Dirección de Tecnologías para que le sea asignado un correo.");      
      this.mostrandoBuscarPersona = true;
    }
  }
  clickMostrarBuscarPersona() {
    this.mostrandoBuscarPersona = true;
  }
  clickOcultarBuscarPersona() {
    this.mostrandoBuscarPersona = false;
  }

}
